import { render, staticRenderFns } from "./wzvz_cs_overview.vue?vue&type=template&id=a6203718&scoped=true"
import script from "./wzvz_cs_overview.vue?vue&type=script&lang=js"
export * from "./wzvz_cs_overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6203718",
  null
  
)

export default component.exports